// src/sections/overview/PlatformOverview.tsx
import React from "react";
import { Search, Cpu, Repeat, Coins, ShieldCheck } from "lucide-react";
import "../../styles/pages/overview/platform.css";

const PlatformOverview: React.FC = () => {
  const features = [
    {
      title: "Discovery",
      desc: "Identify the Craft and Need within your local household. Our AI surfaces hidden skills often lost in secular markets.",
      icon: <Search size={20} />,
      tag: "Map the Oikos",
    },
    {
      title: "Gatekeeper",
      desc: "An AI-powered matchmaking layer that structures trust through faith-aligned verification and covenant-based partnerships.",
      icon: <Cpu size={20} />,
      tag: "Verification",
    },
    {
      title: "Circular Transaction",
      desc: "Enable value flow with Kingdom skill-swaps. Ensure wealth stays within the household.",
      icon: <Repeat size={20} />,
      tag: "Flow Control",
    },
    {
      title: "Stewardship",
      desc: "Wealth is not the goal; it is the by-product of purpose. Orra transforms latent skills into a Kingdom Circular Economy.",
      icon: <Coins size={20} />,
      tag: "By-Product",
    },
    {
      title: "Covenant Trust",
      desc: "Structure trust through a faith-aligned verification layer, moving beyond networking into true partnership.",
      icon: <ShieldCheck size={20} />,
      tag: "Protocol",
    },
  ];

  return (
    <section className="platform-gallery-section">
      <div className="container">
        <div className="platform-header-v2">
          <span className="waitlist-pill-label">The Protocol</span>
          <h2 className="waitlist-main-title">
            The Intelligence Layer <br />
            <span className="serif-italic">for the Kingdom Wealth.</span>
          </h2>
          <p className="waitlist-sub-text">
            Orra transforms latent professional skills into a visible,
            trust-based economy, stopping leakage before it starts.
          </p>
        </div>

        <div className="perspective-container">
          {features.map((feature, idx) => (
            <div key={idx} className={`perspective-card card-arch-${idx}`}>
              <div className="card-top-content">
                <div className="card-icon-box">{feature.icon}</div>
                <span className="card-category-tag">{feature.tag}</span>
              </div>

              <div className="card-bottom-content">
                <h3 className="card-feature-title">{feature.title}</h3>
                <p className="card-feature-desc">{feature.desc}</p>
              </div>
              <div className="glass-glare" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformOverview;
